export default "__VITE_ASSET__4921d81d__"